export default {
    search: 'Search {title}',
    title: {
        trends: 'Trends',
        regions: 'Region',
        industries: 'Industry',
        innovationTypes: 'Innovation-type',
        sdgs: 'SDGs'
    },
    close: 'Close'
}
